import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames';
import React from 'react';
import { Icon } from '../../Icon';
import styles from './styles.scss';
export var IconCellRenderer = function IconCellRenderer(props) {
  var _classes;

  var classes = (_classes = {}, _defineProperty(_classes, styles.iconWarning, props.icon === 'status-warning'), _defineProperty(_classes, styles.iconInfo, props.icon === 'status-info'), _classes);
  return React.createElement("div", {
    className: styles.wrapper
  }, React.createElement(Icon, {
    icon: props.icon,
    className: cx(classes)
  }), " ", props.text);
};
IconCellRenderer.defaultProps = {
  text: ''
};